<template>
	<div class="modal-tbf active modal-register">
        <div class="container-modal form-modal">
            <div class="container-holder">
                <div class="header-modal mb-0">
                    <div class="title">{{ $t('register_success.title') }}</div>
                    <div class="description">Plata a fost procesată cu succes. Îți trimitem pe e-mail datele de acces la curs, iar factura fiscală se trimite în Spațiul Privat Virtual e-Factura. Procesul acesta poate dura până la 72 de ore.
                    <br>
                    Poți să ne scrii la <a href="mailto:contact@tbf.ro">contact@tbf.ro</a> pentru orice nelămurire. Te vom ajuta cu plăcere în cel mai scurt timp posibil.
</div>
                </div>
            </div>
        </div>
        <!-- <transition name="slide" mode="out-in">
            <div class="register-success-tbf">
                <div class="success-modal">
                    <div class="content-modal">
                        <div class="fe-btn-translation p-absolute" @click="$root.$emit('open_modal_translation', 'Register Success', arrayTranslations)" v-if="globalTranslate">OPEN TRANSLATION</div>

                        <div class="content-icon success-register">
                        </div>
                        <div class="title">{{ $t('register_success.title') }}</div>
                        <div class="container-content-modal">
                            <div class="container-message">
                                Mulțumim! În următoarele minute vei primi pe email detaliile de acces la curs. Dacă nu ai primit datele de acces în 60 de minute, ne poți scrie la contact@tbf.ro
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition> -->
    </div>
</template>

<script>

export default {
	data(){
		return {
            arrayTranslations: [
                'register_success.title',
                'register_success.description',
                'register_success.button-action'
            ]
		}
	},
	methods: {
        // redirect() {
        //     // this.$auth.fetch();
        //     // this.$router.push("/obiective");
        // }
	}
}
</script>